module.exports = require('./helpers/bundle-url').getBundleURL('lly8x') + "background-brand.41dd77f7.jpg" + "?" + Date.now();